import { render, staticRenderFns } from "./chanPinTable.vue?vue&type=template&id=06c6a563"
import script from "./chanPinTable.vue?vue&type=script&lang=js"
export * from "./chanPinTable.vue?vue&type=script&lang=js"
import style0 from "./chanPinTable.vue?vue&type=style&index=0&id=06c6a563&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports